/*eslint-disable */

import React, { useEffect, useState } from "react";

export const Homepage = () => {

  useEffect(() => {
    window.location.replace("http://www.medium.com/@benjamindendas");
  }, []);
};
